import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KeypadComponent } from '../keypad/keypad.component';
import { TwilioService } from '../../../patient-on-boarding-portal/service/twilio.service';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-new-call-container',
  imports: [KeypadComponent, CommonModule, NgbTooltipModule],
  templateUrl: './new-call-container.component.html',
  styleUrl: './new-call-container.component.css',
})
export class NewCallContainerComponent {
  @Input() mute: boolean = false;
  @Input() isOnCall: boolean = false;
  @Input() formattedTime: string = '00:00:00';
  @Input() showKeypad: boolean = true;
  @Input() clinicName: string = '';
  @Input() patientName: string = '';
  @Input() showProfileButton: boolean = false;

  @Output('EndCall') Endcall = new EventEmitter<any>();
  @Output() ToggleMic = new EventEmitter<any>();
  @Output() ViewProfile = new EventEmitter<void>();

  userName: string = '';
  userImage: string | null = null;

  constructor(private twilio: TwilioService) {
    this.loadUserInfo();
  }

  loadUserInfo() {
    try {
      const settings = localStorage.getItem('userSettings');
      if (settings) {
        const parsed = JSON.parse(settings);
        this.userName = parsed?.userInfo?.first_name || '';
        this.userImage = parsed?.userInfo?.imagePath || null;
      }
    } catch (e) {
      this.userName = '';
      this.userImage = null;
    }
  }

  toggleMic() {
    this.ToggleMic.emit();
  }

  viewProfile() {
    this.ViewProfile.emit();
  }

  endcall() {
    this.Endcall.emit();
  }

  handleKeypadEvent(event: any) {
    if (event?.type === 'digit') {
      this.sendDTMF(event.value);
    }
  }

  sendDTMF(digit: string) {
    this.twilio.sendDigit(digit);
  }
}
